// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__13inH","label":"styles_label__2gmOP"};